var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg14",
    viewBox: "0 0 24 24",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata20"
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    stroke: "#bebebe",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    r: 11.5,
    cy: 12,
    cx: 12
  }))), /*#__PURE__*/React.createElement("rect", {
    y: 7,
    x: 7,
    height: 8,
    width: 8,
    style: {
      fill: "#ffffff",
      stroke: "#00488E",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      stroke: "#00488E",
      strokeOpacity: 1
    },
    width: 8,
    height: 8,
    x: 9.5,
    y: 9.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.b83de8ed872bed09dc8ab2eaa836d711.svg";
export { ForwardRef as ReactComponent };